import { http } from '../../http';
import {
    RequestGetOrganisationalTable,
    RequestUpdateOrganisationalTableLayout,
    ResponseGetOrganisationalTable,
} from './organisationalResultsModel';

export const postOrganisationalResultsTable = async (data: RequestGetOrganisationalTable) => {
    return await http
        .post<ResponseGetOrganisationalTable>('/organisational-insights/table', data)
        .then((response) => response.data)
        .catch((error) => {
            console.error('Error fetching organisational results table:', error);
            throw error;
        });
};

export const updateOrganisationalTableLayout = async (
    data: RequestUpdateOrganisationalTableLayout
) => {
    return await http
        .patch<void>('/organisational-insights/table-layout', data)
        .then((response) => response.data)
        .catch((error) => {
            console.error('Error updating organisational results table layout:', error);
            throw error;
        });
};
